import React from "react";

/*props: progressA, index, sectionName, editMode, handleChange */
const StatusBox = (props) => {
  const elemId = "section" + props.index + "status";
  const progA = props.progressA.split(",");
  let status = progA[props.index] || "0";
  const checked = status == "1";
  return props.editMode ? (
    <div className={"alert alert-" + (checked ? "success" : "danger")}>
      <input
        id={elemId}
        type="checkbox"
        checked={checked}
        value={checked ? "1" : "0"}
        onChange={(e) => props.handleChange(props.index, e)}
      />
      <label className="pl-2" htmlFor={elemId}>
        {props.sectionName}
      </label>
    </div>
  ) : (
    ""
  );
};

export default StatusBox;
